import {inject, Injectable, Signal, signal, WritableSignal} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {environment} from '../../../../../environments/environment.development';
import {IContact} from '../../interfaces/contact.interface';
import {catchError, finalize, Observable, throwError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  #http: HttpClient = inject(HttpClient);
  #apiContactUrl: string = `${environment.apiUrl}/tools/contact`;
  #loading: WritableSignal<boolean> = signal(false);

  loading: Signal<boolean> = this.#loading.asReadonly();

  contact(contact: IContact): Observable<string> {
    this.#loading.set(true);
    return this.#http.post<string>(`${this.#apiContactUrl}`, contact).pipe(
      catchError((_err: HttpErrorResponse) => {
        return throwError(() => new Error('An error occurred while sending the message'));
      }),
      finalize(() => this.#loading.set(false))
    );
  }

}
